import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Truck, RotateCcw } from 'lucide-react';
export function Guarantee() {
  return <section className="py-24 bg-[#1B5E20]/5 border-y border-[#1B5E20]/10" data-id="element-80">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-82">
          <div className="w-24 h-24 bg-[#1B5E20] rounded-full flex items-center justify-center mb-8 shadow-lg text-white" data-id="element-83">
            <ShieldCheck size={48} data-id="element-84" />
          </div>

          <h4 className="text-[#1B5E20] font-bold tracking-widest uppercase text-sm mb-4" data-id="element-85">
            GARANTÍA DE SATISFACCIÓN 30 DÍAS
          </h4>

          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-86">
            Tu Bienestar Está Garantizado
          </h2>

          <p className="text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed mb-12" data-id="element-87">
            Si en 30 días no ves resultados reales en tu digestión y bienestar,
            te devolvemos tu dinero completo. Sin preguntas, sin complicaciones.
            Así de seguros estamos de nuestros productos.
          </p>

          <div className="flex flex-wrap justify-center gap-6 sm:gap-12 text-[#1A1A1A] font-medium" data-id="element-88">
            <div className="flex flex-col items-center gap-2" data-id="element-89">
              <Lock className="text-[#4CAF50]" size={24} data-id="element-90" />
              <span className="text-sm" data-id="element-91">Compra Segura</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-92">
              <CreditCard className="text-[#4CAF50]" size={24} data-id="element-93" />
              <span className="text-sm" data-id="element-94">Pago Protegido</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-95">
              <Truck className="text-[#4CAF50]" size={24} data-id="element-96" />
              <span className="text-sm" data-id="element-97">Envío Garantizado</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-98">
              <RotateCcw className="text-[#4CAF50]" size={24} data-id="element-99" />
              <span className="text-sm" data-id="element-100">Devolución Fácil</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}